import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { dateFormat } from '@/utils/index.js'
// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/capital/order/page',
    method: 'get',
    params
  })
}
export function getList2API(params) {
    return http({
        url: '/admin/capital/order/page/v2',
        method: 'get',
        params
    })
}

// 全部导出
export function DownloadAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/capital/order/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      let filename = `OK租机资方订单列表${dateFormat()}.xlsx`;
      a.setAttribute('download', decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch(error => {
      hideScreenLoading();
      console.log(error);
    })
}
export function Download2API(data) {
    showScreenLoading()
    axios({
        method: 'post',
        url: '/api/admin/capital/order/export/v2',
        responseType: 'blob',
        data,
        headers: {
            Authorization: getToken() || ''
        }
    })
        .then(async res => {
            hideScreenLoading()
            let data = res.data;
            let url = window.URL.createObjectURL(new Blob([data]));
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            let filename = `OK租机资方订单列表（新）${dateFormat()}.xlsx`;
            a.setAttribute('download', decodeURIComponent(filename));
            document.body.appendChild(a);
            a.click(); //执行下载
            window.URL.revokeObjectURL(a.href); //释放url
            document.body.removeChild(a); //释放标签
        })
        .catch(error => {
            hideScreenLoading();
            console.log(error);
        })
}